module.exports = __webpack_public_path__ + "static/media/circle_and_lines.61a0a704.svg";